import React, { useId } from "react";
import PropTypes from "prop-types";

import "./SettingsLayout.scss";

const SettingsToggle = ({ label, description, checked, onChange, disabled, name }) => {
    const generatedId = useId();
    const controlId = name ? `${name}-${generatedId}` : generatedId;

    const handleChange = (event) => {
        onChange(event.target.checked);
    };

    return (
        <div className="settings-option settings-option--toggle">
            <div className="settings-option__details">
                <span className="settings-option__label" id={`${controlId}-label`}>
                    {label}
                </span>
                {description && (
                    <span className="settings-option__description" id={`${controlId}-description`}>
                        {description}
                    </span>
                )}
            </div>
            <label className="settings-option__control" htmlFor={controlId}>
                <input
                    id={controlId}
                    name={name}
                    type="checkbox"
                    checked={checked}
                    onChange={handleChange}
                    disabled={disabled}
                    aria-labelledby={`${controlId}-label`}
                    aria-describedby={description ? `${controlId}-description` : undefined}
                />
                <span className="settings-option__switch" aria-hidden="true" />
            </label>
        </div>
    );
};

SettingsToggle.propTypes = {
    label: PropTypes.node.isRequired,
    description: PropTypes.node,
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    name: PropTypes.string,
};

SettingsToggle.defaultProps = {
    description: "",
    checked: false,
    disabled: false,
    name: undefined,
};

export default SettingsToggle;
